
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.625 4.218L3.024.617a.398.398 0 00-.565 0l-1.2 1.2a.396.396 0 00-.116.285c0 .108.044.208.116.284l2.117 2.117-2.117 2.116a.4.4 0 00.004.568l1.204 1.197c.08.076.18.116.28.116.1 0 .205-.04.285-.116l3.597-3.597a.398.398 0 000-.565l-.004-.004z"}})])
          )
        }
      }
    